export const blockIconsHardwareComputerNew = (
	<span className='material-symbols-outlined'>computer</span>
);
